/**
 * Type for every section heading inside the sidebar panel beside the rail:
 * Pinned / Projects / Recent in Chats, Apps, the Scheduled lists, My Drive's
 * Workspace / Favorites / Drives, and Work Chats' channel groups. Colour and
 * spacing stay with each heading; size, weight and line height come from the
 * `type-section-label` role (14/18 medium, ChatGPT's section headings).
 * Headings keep their sentence case.
 */
export const SIDEBAR_SECTION_LABEL_CLASS = 'type-section-label';
